import { CompactLogoIcon } from '../svgs/icons/CompactLogoIcon';

export const LoadingLogo = ({ size }: { size: number }) => {
	return <CompactLogoIcon width={size} height={size} loading />;
};
